var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0774 8.30322L7.53618 11.4593C7.14771 11.8055 6.62083 12 6.07144 12C5.52206 12 4.99518 11.8055 4.60671 11.4593C4.21824 11.1131 4 10.6435 4 10.1539C4 9.66424 4.21824 9.19466 4.60671 8.84844L9.64259 4.3603C9.77087 4.24604 9.92314 4.1554 10.0907 4.09358C10.2583 4.03176 10.4379 3.99996 10.6193 4C10.8006 4.00004 10.9802 4.03191 11.1477 4.0938C11.3153 4.1557 11.4675 4.24639 11.5957 4.36071C11.7239 4.47504 11.8256 4.61075 11.895 4.7601C11.9644 4.90944 12 5.06951 12 5.23115C12 5.39278 11.9642 5.55283 11.8947 5.70215C11.8253 5.85147 11.7235 5.98714 11.5953 6.10141L6.5557 10.5928C6.42496 10.7045 6.25021 10.7656 6.06912 10.7635C5.88802 10.7615 5.71508 10.6961 5.58756 10.5815C5.46004 10.4669 5.38815 10.3122 5.38739 10.1508C5.38664 9.98937 5.45707 9.83415 5.58351 9.71859L9.17859 6.51453M6.55984 10.5887L6.55524 10.5928",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.4360d5bcfd615c7d8779adec39a956a1.svg";
export { ForwardRef as ReactComponent };